import { ESTIMATE_ITEM_STATUSES } from "../../../../../constants";

export const filterNotConfirmedSections = (sections) => sections.filter(
  (section) => section.status === ESTIMATE_ITEM_STATUSES.CONFIRMED
);